import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconViewDarkgrey({ size = "100", ...props }: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<path
				fill="#333"
				fillRule="nonzero"
				d="M12.062 8.073a5 5 0 0 0-1.2.192c.152.266.276.73.279 1.037a2.15 2.15 0 0 1-2.151 2.151 2.5 2.5 0 0 1-1.038-.278 5.2 5.2 0 0 0-.168 1.189 4.293 4.293 0 0 0 4.291 4.29 4.293 4.293 0 0 0 4.291-4.29 4.293 4.293 0 0 0-4.29-4.291zm10.93 3.741C20.907 7.75 16.783 5 12.061 5S3.216 7.752 1.134 11.815a1.5 1.5 0 0 0-.134.56c0 .164.06.415.134.56C3.217 17 7.34 19.75 12.062 19.75s8.847-2.752 10.93-6.815c.073-.146.133-.397.133-.56s-.06-.415-.134-.56m-10.93 6.092c-3.789 0-7.263-2.112-9.139-5.531 1.876-3.419 5.35-5.531 9.14-5.531s7.263 2.112 9.139 5.531c-1.876 3.419-5.35 5.531-9.14 5.531"
			/>
		</svg>
	);
}
